//Import Dependencies
import * as React from 'react';
import Collapse from 'antd/lib/collapse';
import { useState } from 'react';
import {
    NotificationModel,
} from './model';
import {
    NotificationProps,
} from './props';
import {
    ErrorObject
} from 'one-state-error/src/errorobject';

/**
 *  card renders all Bell Notification
 * @param props component properties
 * @returns the JSX of Bell Notification
 */
export const NotificationCard = <M extends NotificationModel>(
    props: NotificationProps<M>
) => {
    const {
        model,
    } = props;

    const {
        errorobject,
    } = model;

    const { Panel } = Collapse;
    let key = 1;
    const [panelkey, setPanelkey] = useState(key);

    function callback(keypanel: any) {
        setPanelkey(keypanel)
    }
    let paneldiv: any = [];

    errorobject.forEach((obj: ErrorObject) => {
        if (Array.isArray(obj?.erroritems)) {
            let title = obj?.type;
            if (title == "error") {
                title = "API Error";
            }
            title = title + " - " + obj?.source
            let temppanel = (
                <Panel header={title} key={key}>
                    <p>{obj?.erroritems[0]?.error_code} - {obj?.erroritems[0]?.error_type}</p>
                    <p>{obj?.erroritems[0]?.display_text ? obj?.erroritems[0]?.display_text : obj?.erroritems[0]?.error_detail}</p>
                    <p><b>Date:</b>&nbsp;{obj?.error_date}&nbsp;&nbsp;<b>Time:</b>&nbsp;{obj?.error_time}</p>
                    {/* <p>{obj.erroritems[0].error_description}</p> */}
                </Panel>
            )
            key = key + 1;
            paneldiv.push(temppanel)
        }
    })

    return (
        <div className="notificationdiv">
            <Collapse
                activeKey={panelkey}
                defaultActiveKey={panelkey}
                onChange={callback}
                destroyInactivePanel={true}
                accordion >
                {paneldiv}
            </Collapse>
        </div>
    );
};
